import ACTIONS from '../actions';

export default function usersReducer(state, action) {
  switch(action.type) {
    case ACTIONS.CREATE_USER_START:
      return {
        ...state,
        isLoading: true
      };
    case ACTIONS.CREATE_USER_COMPLETE:
      return {
        ...state,
        newUser: action.payload,
        isLoading: false
      };
    case ACTIONS.CREATE_USER_FAILED:
      return {
        ...state,
        newUser: action.payload,
        isLoading: false
      };
    case ACTIONS.GET_ALL_USERS:
      return {
        ...state,
        allUsers: action.payload
      };
    case ACTIONS.GET_ALL_PARTNERS:
      return {
        ...state,
        allPartners: action.payload
      };
    case ACTIONS.GET_ALL_STAFF:
      return {
        ...state,
        allStaff: action.payload
      };
    case ACTIONS.UPDATE_PARTNER_INFO_COMPLETE:
    const updatedPartners = state.allPartners.map(partnerInfo => partnerInfo._id === action.payload._id ? action.payload : partnerInfo);
    return {
        ...state,
        allPartners: updatedPartners
      };
    case ACTIONS.GET_ALL_CLINIC_PARTNERS:
      return {
        ...state,
        allClinicPartners: action.payload
      };
    default: 
      return state
  }
}